module.exports = __webpack_public_path__ + "static/media/bad-review2.73fbed40.png";